import { Link } from 'react-router-dom';
import { useSeo } from '../components/custom/Seo';

const links = [
  { name: 'Home', path: '/' },
  { name: 'Latest News', path: '/' },
  { name: 'Commanders', path: '/commanders' },
  { name: 'Nationals', path: '/nationals' },
  { name: 'Capitals', path: '/capitals' },
  { name: 'Wizards', path: '/wizards' },
];

export default function NotFound() {
  useSeo({
    title: 'Page Not Found | DC Sports Report',
    description: 'The page you are looking for could not be found on DC Sports Report.',
    noindex: true,
  });

  return (
    <div data-testid="not-found-page" className="min-h-[70vh] bg-white flex items-center">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        <img
          src="https://customer-assets.emergentagent.com/job_dcsportshub/artifacts/fw8w9adx_DCSportsReport_Logo.png"
          alt="DC Sports Report"
          className="h-20 w-auto mx-auto"
        />
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#BF0A30] mt-8">Error 404</p>
        <h1 className="font-serif-head font-extrabold text-3xl sm:text-4xl text-slate-900 tracking-tight mt-3">
          Page Not Found
        </h1>
        <p className="text-slate-600 text-base leading-relaxed mt-4">
          The story you're looking for may have moved, or the link may be incorrect.
          Here's where to pick the coverage back up:
        </p>
        <div className="flex flex-wrap justify-center gap-3 mt-8">
          {links.map((l, i) => (
            <Link
              key={l.name}
              to={l.path}
              data-testid={`notfound-link-${l.name.toLowerCase().replace(' ', '-')}`}
              className="px-5 py-2.5 border border-slate-300 text-sm font-heading font-medium uppercase tracking-wide text-slate-800 hover:bg-[#002868] hover:text-white hover:border-[#002868] transition-colors"
            >
              {l.name}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
